<div class="flex-row print:hidden">
  <div class="navbar h-16 border-b border-base-300 bg-base-200">
    <div class="relative h-full flex-1">
      <a
        class="mr-2 h-full px-2 text-center text-4xl font-medium normal-case"
        [routerLink]="['/']"
        style="font-family: 'Source Sans Pro', Arial, Helvetica, sans-serif"
      >
        <img class="inline-block h-full" src="/assets/accuzip-logo.svg" />
        <img
          class="ml-3 inline-block h-8"
          src="/assets/accuzip-logo-text.svg"
        />
      </a>
      @if (currentTenant && viewService.currentView === 'user' && signedIn) {
        <div
          class="tooltip tooltip-right"
          data-tip="Click to copy account number"
        >
          <button class="btn btn-sm shadow-none" (click)="copyAccountNumber()">
            <div class="flex items-center">
              Account #: {{ currentTenant.account_number }}
              <app-file-copy-icon class="h-4 w-4"></app-file-copy-icon>
            </div>
          </button>
        </div>
      }
    </div>
    <div class="flex-none space-x-4 text-base">
      @if (viewService.currentView === 'user' && signedIn) {
        <div class="indicator mr-4">
          @if (cartItemCount > 0) {
            <span class="badge indicator-item badge-primary top-1">
              {{ cartItemCount }}
            </span>
          }

          <div class="tooltip tooltip-bottom mt-2" data-tip="Cart">
            <a routerLink="/cart">
              <app-cart-icon
                class="inline-block h-8 w-8 cursor-pointer text-current"
              ></app-cart-icon>
            </a>
          </div>
        </div>
      }

      <app-theme-toggle
        class="tooltip tooltip-bottom"
        data-tip="Light/Dark mode toggle"
      ></app-theme-toggle>

      <!-- <div>
        <div class="tooltip tooltip-bottom" data-tip="Tasks">
          <button class="btn btn-square">
            <app-clipboard-icon
              class="h-8 w-8 text-current"
            ></app-clipboard-icon>
          </button>
        </div>
        <div class="tooltip tooltip-bottom" data-tip="Notifications">
          <button class="btn btn-square">
            <app-bell-icon class="h-8 w-8 text-current"></app-bell-icon>
          </button>
        </div>
      </div> -->
      @if (signedIn) {
        <div class="dropdown dropdown-end">
          <div class="tooltip tooltip-bottom" data-tip="Profile">
            <label tabindex="0" class="btn avatar btn-circle btn-ghost">
              <div class="w-10 rounded-full">
                @if (userImageURL) {
                  <img src="{{ userImageURL }}" />
                } @else {
                  <app-user-icon class="text-current"></app-user-icon>
                }
              </div>
            </label>
          </div>
          <ul
            tabindex="0"
            class="menu dropdown-content menu-sm z-[1] mt-3 w-60 rounded-box bg-secondary p-2 text-secondary-content shadow"
          >
            @if (currentTenant) {
              <li (click)="copyAccountNumber()">
                <div class="flex items-center">
                  Account #: {{ currentTenant.account_number }}
                  <app-file-copy-icon class="h-4 w-4"></app-file-copy-icon>
                </div>
              </li>
            }
            <li><a [routerLink]="['/tenant/settings']">Company Settings</a></li>
            <li><a [routerLink]="['/user-settings']">User Settings</a></li>
            <li (click)="signOut()"><a>Logout</a></li>
          </ul>
        </div>
      } @else {
        <div>
          <button class="btn btn-neutral btn-sm" [routerLink]="['/login']">
            Login
          </button>
        </div>
      }
    </div>
  </div>
</div>
